<template>
  <div>
  <Breadcrumbs main="Request" title="Statement Request" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Account Statement Request</h5>
                <span>Submit your request below.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                      <form class="theme-form is-validated" id="Submit_Transfer_Form">
                          <!-- Initiate the Transfer -->
                          <div id="InitiateTransfer" v-show="step === 1">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Account Number <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-select acct-num"  name="AccountNumber" required="required"><option value="" disabled>Select From Account *</option>
                                        <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="startDate">Start Date <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                            <datepicker placeholder="Start Date" input-class="datepicker-here form-control calendar-input digits" :disabledDates="disabledDates" :format="format" v-model="form.startDate" ></datepicker>
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="endDate">End Date <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                            <datepicker placeholder="End Date" input-class="datepicker-here form-control calendar-input digits" :disabledDates="disabledDates" :format="format" v-model="form.endDate" ></datepicker>
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" />
                                        <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                        <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                    </div>
                                </div>
                              <div class="row mt-4">
                                  <div class="col-sm-12 offset-lg-3 offset-sm-0 mt-4">
                                      <button type="button" @click="requestAccountStatement" class="btn btn-round btn-primary mr-1">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                                      </div>
                                      <div v-else>
                                        Submit<i class="fa fa-save ml-2"></i>
                                      </div>
                                      </button>
                                      <button type="button" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div id="RequestSuccessResponseSection" v-show="step === 2" class="animated fadeIn" style="display:block">
                <div class="table-responsive mt-0">
                    <table id="example" class="display table table-striped" style="width:100%">
                      <thead class="font-weight-bold">
                        <tr class="text-left">
                          <th>Transaction Date</th>
                          <th>Value Date</th>
                          <th>Branch</th>
                          <th>Transaction Details</th>
                          <th>Reference</th>
                          <th>Deposit</th>
                          <th>Withdrawal</th>
                          <th>Balance</th>
                        </tr>
                      </thead>
                    <tbody>
                    <tr class="text-left" v-for="history in accountStatmentHistory" :key="history.id">
                        <td>{{history.transDate}}</td>
                        <td>{{history.valueDate}}</td>
                        <td>{{history.tranBranch}}</td>
                        <td>{{history.transDetails}}</td>
                        <td>{{history.reference}}</td>
                        <td class="text-success">{{history.credit === 'C' ? `₦${history.transAmt}` : ''}}</td>
                        <td class="text-danger">{{history.debit === 'D' ? `₦${history.transAmt}` : ''}}</td>
                        <td>{{`₦${history.runningBalance}`}}</td>
                      </tr>
                    </tbody>
                </table>
                  <div v-if="accountStatmentHistory.length === 0" class="text-center text-danger py-4">
                    <i class="fa fa-exclamation-triangle fa-2x"></i>
                    <p class="mt-2">No Records Found</p>
                    <button type="button" @click="resetForm" class="btn btn-danger">Go Back</button>
                  </div>
                </div>
                <div class="text-center py-4" v-if="accountStatmentHistory.length >= 1">
                  
                  <!-- <button type="button" class="btn btn-danger" @click="sendToMail">
                    <div v-if="loading">
                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                      </div>
                      <div v-else>
                        Send to mail <i class="fa fa-send ml-2"></i>
                    </div>
                  </button> -->
                  <button type="button" @click="resetForm" class="btn btn-danger">Go Back</button>
                  <button type="button" class="btn btn-outline-danger" @click="downloadStatemnt('account_statement.pdf')">Download <i class="fa fa-download ml-2"></i></button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import { decrypt } from '../../_services/encryption';
  export default {
    components: {
      Datepicker
    },
    data:() => ({
      format: 'dd-MM-yyyy',
      disabledDates: {
        from: new Date(Date.now()),
      },
      form: {
        accountNumber: '',
        startDate: '',
        endDate: '',
        type: 8,
        transactionPin: '',
        platform: 1,
      },
      accountStatmentHistory: [],
      step: 1,
      loading: false,
      type: 'password',
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
      }),
    },
    async mounted() {
    },
    methods : {
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      // show pin
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      requestAccountStatement() {
        // check if all fields are filled
        if (this.form.accountNumber === '' || this.form.endDate === '' || this.form.startDate === '' || this.form.transactionPin === '') {
          this.$swal({
            title: 'Oops..',
            text: 'Please fill all the required fields',
            type: 'error',
          });
          return;
        } else {
          this.loading = true;
          this.form.startDate = moment(this.form.startDate).format('YYYY-MM-DD');
          this.form.endDate = moment(this.form.endDate).format('YYYY-MM-DD');
          this.$store.dispatch('requests/requestAccountStatement', this.form).then((response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (userParseData.acctStmtHist === null) {
              this.loading = false;
              this.$swal({
                title: 'Success',
                text: userParseData.responseDescription,
                type: 'success',
              }).then(() => {
                window.location.reload();
              });
            } else {
              this.loading = false;
              this.accountStatmentHistory = userParseData.acctStmtHist;
              this.step++;
            }
          }).catch((error) => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops..',
              text: objError.errors[0],
              type: 'error',
            });
          });
        }
      },
      sendToMail() {
        this.loading = true;
        const data = {
          accountNumber : this.form.accountNumber,
          startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.form.endDate).format('YYYY-MM-DD'),
          sendToMail: true,
          platform: this.form.platform,
        };
        this.$store.dispatch('requests/downloadAccountStatement', data).then(() => {
          this.loading = false;
          this.$swal({
            title: 'Success',
            text: 'Your request has been sent to your email',
            type: 'success',
          });
        }).catch((error) => {
          this.loading = false;
          const errorNew = error.response.data;
          // const decryptedError = decrypt(error.response.data);
          // const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops..',
            text: errorNew.errors[0],
            type: 'error',
          });
        });
      },
      downloadStatemnt(fileName) {
        const data = {
          accountNumber : this.form.accountNumber,
          startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.form.endDate).format('YYYY-MM-DD'),
          sendToMail: false,
          platform: this.form.platform,
        };
        this.$store.dispatch('requests/downloadAccountStatement', data).then((response) => {
          // const decryptedData = decrypt(response.data);
          // const userParseData = JSON.parse(decryptedData);
          var blob = new Blob([response.data], { type: 'application/pdf' });
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
        }).catch((error) => {
          const errorNew = error.response.data;
          // const decryptedError = decrypt(error.response.data);
          // const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops..',
            text: '996|A system glitch has occured. Please try again shortly',
            type: 'error',
          });
        });
      },
      resetForm() {
        this.form.accountNumber = '';
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.transactionPin = '';
        this.step = 1;
      },
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
  
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.vdp-datepicker {
  width: 540px !important;
}
@media screen and (max-width: 768px) {
  .vdp-datepicker {
    width: 100% !important;
  }
}
.vdp-datepicker >>> .form-control {
  border-left: 0px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.input-group-text {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 0 !important;
}
.btn-outline-danger {
  border-color: #E41613;
  color: #E41613;
}
</style>